module.exports = __webpack_public_path__ + "img/15.33a5bbd3.png";